<template>
  <div>
    <div class="summary-radio-group border border-3 rounded-top">
      <template v-for="(option, index) in options" :key="option.type">
        <label class="summary-radio-option border-3" :class="{ 'active': modelValue === option.type, 'border-end': index !== options.length - 1, 'rounded-top-left': index === 0, 'rounded-top-right': index === options.length - 1 }">
          <input type="radio" :value="option.type" :checked="modelValue === option.type" @change="emitUpdate(option.type)" />
          <div class="content">
            <i :class="`bi ${option.icon}`"></i>
            <p class="fw-bold">
              {{ option.abbreviation ? `${option.name} (${option.abbreviation})` : option.name }}
            </p>
          </div>
        </label>
      </template>
    </div>

    <div class="summary-radio-option-description border-3 border-bottom border-start border-end rounded-bottom">
      <template v-for="option in options" :key="option.type">
        <div v-if="modelValue === option.type" class="px-3 pt-3 pb-0">
          <p v-for="(p, i) of option.description" :key="i" :class="{ 'mb-1': i == option.description.length - 1 }" v-html="p"></p>
        </div>
      </template>

      <div v-if="$slots.extraContent" class="px-3 pb-3">
        <slot name="extraContent" :selected="modelValue" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string | number;
  options: Array<{
    type: string | number;
    name: string;
    description: Array<string>;
    icon?: string;
    abbreviation?: string;
  }>;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number): void;
}>();

const emitUpdate = (value: string | number) => {
  emit('update:modelValue', value);
};
</script>

<style scoped lang="css">
.summary-radio-group {
    display: flex;
    width: 100%;
}

.summary-radio-option {
    flex: 1;
    cursor: pointer;
    padding: 0.75rem;
    background-color: transparent;
    transition: all 0.3s ease;
    display: flex;
    align-items: stretch;
    justify-content: center;
}

.summary-radio-option.active {
    color: white;
    border-color: #999;
}
.summary-radio-option.active p {
    color: white !important;
}

.summary-radio-option input[type="radio"] {
    display: none;
}

.summary-radio-option .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
}

.summary-radio-option i {
    font-size: 3rem;
}

.summary-radio-option-description {
    color: #000 !important;
}

.rounded-top-left {
    border-top-left-radius: 3px;
}

.rounded-top-right {
    border-top-right-radius: 3px;
}
</style>